module.exports = __webpack_public_path__ + "img/facebook.32e0295e.svg";